import LinkButton from './LinkButton';
import PrintButton from './PrintButton';

globalThis.ButtonComponents = {
  LinkButton,
  PrintButton,
};
